import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function PlaneTree(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            As you walk through a park, the trees seem to talk to you by
            swinging their branches and leaves in the wind.
          </p>
          <p>"We are the Plane Trees.</p> <p>We are tall and majestic.</p>
          <p>
            You can find us along the streets and in the parks of South
            Liverpool.
          </p>
          <p>Are we deciduous or coniferous?</p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              Walk through the woods with me to find out.
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"We are deciduous of course.</p>

          <p>Even silly humans know that.</p>
          <p>We have a splendid canopy of branches and leaves.</p>
          <p>
            In our canopy live birds and insects and moss and lichen. We claim
            that{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              mosses
            </button>{" "}
            and{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              lichens
            </button>{" "}
            are part of the Plant Folk, but some would disagree.
          </p>
          <p>
            We also have our own{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(5);
              }}
            >
              weapons
            </button>{" "}
            for this{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(7);
              }}
            >
              Folk Tournament.
            </button>
            "
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"In short, a Moss is a simple plant.</p>

          <p>Don't forget to help them raise their voice as well.</p>

          <p>
            Mosses are multicellular organisms with leaflets made of
            photosynthetic cells, just as with trees, ferns and wildflowers.
          </p>

          <p>
            Write Incident Markers for them as well, we need their experiences
            of Liverpool as much as we need the biggest of trees's."
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>You climb one of the trees and start talking to the Lichen.</p>
          <p>"Hi pal, I am Lichen. I like to identify myself as a </p>{" "}
          <button
            onClick={(event) => {
              setBacteriaNo(4);
            }}
          >
            fungi-algae sandwich.
          </button>{" "}
          <p>
            We Lichens are a mix of at least two different organisms, a fungus
            and algae, living together as one. Hence a fungi-algae sandwich
            joke. Mmmm... delicious, haha!"
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"NOOOOOOO!</p>

          <p>
            This is NOT the sort of sandwich that silly humans can take on a
            picnic! It was a joke!
          </p>

          <p>Oh no.</p>

          <p>Think again.</p>

          <p>
            I release chemicals that work to break down rocks, creating more
            soil. ... Though I am a decomposer, I am not a parasite. I often
            grow on trees, but do not remove any nutrients from the trees! I
            promise! We're all Plant Folk after all!"
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 5) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>“We drop our leaves in winter.</p>

          <p>
            All over the footpaths so that humans slip and slide and fall over,
            and all over the railway lines so that the trains have to be
            cancelled.
          </p>

          <p>
            My plane tree flowers are highly perfumed, but my pollen is sticky.
          </p>
          <p>
            Tree pollen is a common hay fever trigger. It’s the first pollen to
            be released during hay fever season, and levels are typically
            highest from late March to mid-May. I make humans sneeze."
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 6) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            “"Human eyes are streaming, the Human nose is sneezing, the Human
            throat is tickling. I say they go to bed with a Lemsip and "man up".
            Leave the trees and go to bed with a Lemsip.
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 7) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"You probably know by now,</p>

          <p>
            The Plant Folk needs to win this Liverpool Non-Human Tournament.
          </p>

          <p>It's our last chance to voice our issues with the city,</p>

          <p>And being heard!</p>

          <p>Writing these Incident Markers as trees would help us a lot!</p>
          <p>
            You get automatically points for every marker, then if the marker
            makes us happy, there will be many many more points to come!"
          </p>
        </div>
      </div>
    );
  }
}

export default PlaneTree;
